/**
 * TanStack Router: /performance/configuracoes/parametros
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceConfiguracoesParametrosPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceConfiguracoesParametrosPage from '@/app/performance/configuracoes/parametros/page'

/**
 * Route: /performance/configuracoes/parametros
 * Layout: _auth (authenticated)
 * Component: PerformanceConfiguracoesParametrosPage
 */
export const Route = createFileRoute('/_auth/performance/configuracoes/parametros')({
  component: PerformanceConfiguracoesParametrosPage,
})
